/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "New Project Form" |
*
* @param {New_Project_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_form_aria_label = /** @type {((inputs?: New_Project_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de nouveau projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Projektformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo modulo di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма нового проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de nuevo proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新项目表格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいプロジェクトフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया प्रोजेक्ट फॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário para Novo Projeto")
	return /** @type {LocalizedString} */ ("New Project Form")
});